import React, { Fragment } from 'react';
import { config } from 'helpers';
import { Header, Badge, Button, Image, NoWrap } from 'components';
import css from './middle.scss';

export function Middle(props) {

  return (
    <div className={css.section}>
      <figure className={[css.image, props.visible && css.visible, props.scrolledPast && css.scrolledPast].join(' ')}>
        <img src={require('./iPhone.png')} alt="" />
      </figure>
      <div className={[css.container, props.visible && css.visible, props.scrolledPast && css.scrolledPast].join(' ')}>
        { config.gw &&
          <h3>
            <NoWrap>Effective Online</NoWrap>{ ' ' }
            <NoWrap>Coaching Program &</NoWrap>{ ' ' }
            <NoWrap>Goals Tracking App</NoWrap>
          </h3>
        }

        { config.sw &&
          <h3>
            <NoWrap>Powerful Life</NoWrap>{ ' ' }
            <NoWrap>Coaching Tools and</NoWrap>{ ' ' }
            <NoWrap>Apps</NoWrap>
          </h3>
        }

        <p className={css.line}>
          Our simplified process will allow you to transform your life the way <NoWrap>you want it. </NoWrap>
          You can try your <NoWrap>development plan now!</NoWrap>
        </p>
        <p>
          <Button to="/sign-up/?redirect=/settings/membership/" square blue>Start { config.trialPeriod }</Button>
        </p>
        <ul className={css.badges}>
          <li><Badge.AppStore className={css.badge} /></li>
          <li><Badge.GooglePlay className={css.badge} /></li>
        </ul>
      </div>
    </div>
  );
}
